"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmContentDeletionModal = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importStar(require("@components/Button"));
var Checklist_1 = __importDefault(require("@/react-app/common/components/Checklist"));
function ConfirmContentDeletionModal(_a) {
    var currentTeamName = _a.currentTeamName, setIsModalOpen = _a.setIsModalOpen, onClickOnConfirmButton = _a.onClickOnConfirmButton;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read((0, react_1.useState)([
        { id: 0, text: t('settings:DELETE_ALL_CONTENT.MODAL.TEXT2'), confirmed: false },
        { id: 1, text: t('settings:DELETE_ALL_CONTENT.MODAL.TEXT3'), confirmed: false },
        { id: 2, text: t('settings:DELETE_ALL_CONTENT.MODAL.TEXT4'), confirmed: false },
    ]), 2), conditions = _b[0], setConditions = _b[1];
    var isAllConditionsConfirmed = conditions.every(function (condition) { return condition.confirmed; });
    return (react_1.default.createElement("div", { className: "delete-content-modal" },
        react_1.default.createElement("div", { className: "delete-content-modal-header" },
            react_1.default.createElement("p", { className: "title" }, t('settings:DELETE_ALL_CONTENT.MODAL.TITLE')),
            react_1.default.createElement("p", null, currentTeamName),
            react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: t('settings:DELETE_ALL_CONTENT.MODAL.TEXT1') || '' } })),
        react_1.default.createElement("div", { className: "delete-content-modal-confirm" },
            react_1.default.createElement("h4", null, t('settings:DELETE_ALL_CONTENT.MODAL.TEXT5')),
            react_1.default.createElement(Checklist_1.default, { conditions: conditions, setConditions: setConditions }),
            react_1.default.createElement("div", { className: "gdpr__button-group" },
                react_1.default.createElement(Button_1.SecondaryButton, { onClick: function () { return setIsModalOpen(false); }, text: t('settings:DELETE_ALL_CONTENT.MODAL.BUTTON_CANCEL') }),
                react_1.default.createElement(Button_1.default, { onClick: onClickOnConfirmButton, text: t('settings:DELETE_ALL_CONTENT.MODAL.BUTTON_CONFIRM'), disabled: !isAllConditionsConfirmed })))));
}
exports.ConfirmContentDeletionModal = ConfirmContentDeletionModal;
